<template>
    <div>
        <div class="">
            <!-- LOADER -->
            <div v-if="loadingGetData" class="flex justify-center py-20">
                <div class="w-16 h-16 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
            </div>

            <div v-if="!loadingGetData">

                <!-- INFOS -->
                <div class="bg-white rounded-xl shadow p-6 mb-6 border">
                    <h2 class="text-lg font-medium mb-4">Informations générales</h2>

                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

                        <div>
                            <label class="text-sm">Nom</label>
                            <input v-model="form.nom" type="text" class="w-full border rounded px-3 py-2 text-sm">
                        </div>

                        <div>
                            <label class="text-sm">SIRET</label>
                            <input v-model="form.siret" type="text" class="w-full border rounded px-3 py-2 text-sm">
                        </div>

                        <div>
                            <label class="text-sm">Numéro capacité</label>
                            <input v-model="form.num_capacite" type="text" class="w-full border rounded px-3 py-2 text-sm">
                        </div>

                        <div>
                            <label class="text-sm">Téléphone</label>
                            <input v-model="form.tel" type="text" class="w-full border rounded px-3 py-2 text-sm">
                        </div>

                        <div>
                            <label class="text-sm">Email</label>
                            <input v-model="form.mail" type="email" class="w-full border rounded px-3 py-2 text-sm">
                        </div>

                        <div>
                            <label class="text-sm">URL Google Avis</label>
                            <input v-model="form.url_google_avis" type="text" class="w-full border rounded px-3 py-2 text-sm">
                        </div>

                    </div>
                </div>

                <!-- RESPONSABLE -->
                <div class="bg-white rounded-xl shadow p-6 mb-6 border">
                    <h2 class="text-lg font-medium mb-4">Responsable</h2>

                    <div class="grid grid-cols-2 gap-4">
                        <input v-model="form.responsable_prenom" placeholder="Prénom" class="border rounded px-3 py-2 text-sm">
                        <input v-model="form.responsable_nom" placeholder="Nom" class="border rounded px-3 py-2 text-sm">
                    </div>

                    <div class="mt-4">
                        <label class="text-sm block mb-1">Signature</label>
                        <input-file key-name="signature-entreprise" v-model="form.signature_entreprise" />
                        <img v-if="form.signature_entreprise" :src="form.signature_entreprise" class="h-16 mt-2">
                    </div>
                </div>

                <!-- ADRESSE -->
                <div class="bg-white rounded-xl shadow p-6 mb-6 border">
                    <h2 class="text-lg font-medium mb-4">Adresse</h2>

                    <div class="grid grid-cols-2 gap-4">
                        <input v-model="form.adresse" placeholder="Adresse" class="border rounded px-3 py-2 text-sm">
                        <input v-model="form.code_postal" placeholder="Code postal" class="border rounded px-3 py-2 text-sm">
                        <input v-model="form.ville" placeholder="Ville" class="border rounded px-3 py-2 text-sm">
                        <input v-model="form.pays" placeholder="Pays" class="border rounded px-3 py-2 text-sm">
                    </div>
                </div>

                <!-- HORAIRES -->
                <div class="bg-white rounded-xl shadow p-6 mb-6 border">
                    <h2 class="text-lg font-medium mb-4">Horaires</h2>

                    <div class="grid grid-cols-2 gap-4">
                        <input v-model="form.heure_ouverture" type="time" class="border rounded px-3 py-2 text-sm">
                        <input v-model="form.heure_fermeture" type="time" class="border rounded px-3 py-2 text-sm">
                    </div>
                </div>

                <!-- LOGO -->
                <div class="bg-white rounded-xl shadow p-6 mb-6 border">
                    <h2 class="text-lg font-medium mb-4">Logo</h2>
                    <input-file key-name="logo-societe" v-model="form.logo" />
                    <img v-if="form.logo" :src="form.logo" class="h-20 mt-2">
                </div>

                <!-- SAVE -->
                <div >
                    <button
                        @click="save"
                        :disabled="loading"
                        class="bg-orange-600 hover:bg-orange-700 text-white px-8 py-3 rounded-full shadow-lg disabled:opacity-50"
                    >
                        {{ loading ? 'Enregistrement...' : 'Enregistrer' }}
                    </button>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            societeId: this.$route.params.id,

            loading: false,
            loadingGetData: false,

            form: {}
        }
    },

    mounted() {
        this.load()
    },

    methods: {

        async load() {
            this.loadingGetData = true

            let res = await this.$request.post('/admin/societes/view', {
                id: this.societeId
            })

            this.form = { ...res }
            

            this.loadingGetData = false
        },

        async save() {
            this.loading = true

            await this.$request.post('/admin/societe/update', {
                societe_id: this.societeId,
                ...this.form
            })

            this.$toast.success('Société mise à jour')

            this.loading = false
        }
    }
}
</script>
